import React, { useEffect, useState } from "react";
import { Edit, Trash2, Star, Save, X, Plus } from "lucide-react";
import AddReview from "../add-review/add-review";
import { postData } from "../../../services/NodeServices";
import { toast } from "react-toastify";

const AllReviews = () => {
  const [reviews, setReviews] = useState([
    {
      reviewid: 1,
      product_id: 358,
      variant_id: null,
      rating: 4,
      review_text: "the sweatshirt is comfortable and warm, fits well.",
      userid: 2,
      created_at: "2025-09-27 07:07:46",
      username: "alex",
    },
    {
      reviewid: 2,
      product_id: 358,
      variant_id: null,
      rating: 5,
      review_text: "love this sweatshirt! very soft and cozy.",
      userid: 3,
      created_at: "2025-09-27 07:08:33",
      username: "emma",
    },
    {
      reviewid: 3,
      product_id: 358,
      variant_id: null,
      rating: 4,
      review_text: "good quality, but the sleeves are slightly long.",
      userid: 4,
      created_at: "2025-09-27 07:08:33",
      username: "john",
    },
    {
      reviewid: 4,
      product_id: 358,
      variant_id: null,
      rating: 3,
      review_text: "material is okay, expected a bit warmer.",
      userid: 5,
      created_at: "2025-09-27 07:08:33",
      username: "sophia",
    },
    {
      reviewid: 5,
      product_id: 358,
      variant_id: null,
      rating: 5,
      review_text: "perfect fit and stylish design, highly recommend!",
      userid: 6,
      created_at: "2025-09-27 07:08:33",
      username: "michael",
    },
    {
      reviewid: 6,
      product_id: 358,
      variant_id: null,
      rating: 4,
      review_text: "nice color and comfy, washes well too.",
      userid: 7,
      created_at: "2025-09-27 07:08:33",
      username: "olivia",
    },
  ]);

  const [showCustomComponent, setShowCustomComponent] = useState(false);

  const getAllReviews = async () => {
    try {
      const result = await postData("api/products/review/all");

      if (result.status) {
        setReviews(result.data);
      }
    } catch {}
  };

  useEffect(() => {
    getAllReviews();
  }, []);

  const [editingId, setEditingId] = useState(null);
  const [editForm, setEditForm] = useState({
    rating: 5,
    review_text: "",
  });

  const handleEdit = async (review) => {
    setEditingId(review.reviewid);
    setEditForm({
      rating: review.rating,
      review_text: review.review_text,
    });

    try {
   /*    const result = await postData("api/products/review/edit", {
        reviewid: review.reviewid,
        rating: review.rating,
        review_text: review.review_text,
      });
      if (result.status) {
        toast.success("review edited");
      } */
    } catch {}
  };

  const handleSave = async (review) => {
    try {
      const result = await postData("api/products/review/edit", {
        reviewid: review.reviewid,
        rating: review.rating,
        review_text: review.review_text,
      });
      if (result.status) {
        setReviews(
          reviews.map((review) =>
            review.reviewid === review.reviewid
              ? { ...review, ...editForm }
              : review
          )
        );
        setEditingId(null);
        setEditForm({ rating: 5, review_text: "" });

        toast.success("review edited");
      }
    } catch {}
  };

  const handleCancel = () => {
    setEditingId(null);
    setEditForm({ rating: 5, review_text: "" });
  };

  const handleDelete = async (reviewId) => {
    try {
      const result = await postData("api/products/review/delete", {
        reviewid: reviewId,
      });
      if (result.status) {
        setReviews(reviews.filter((review) => review.reviewid !== reviewId));
      }
    } catch {}
  };

  const renderStars = (rating) => {
    return [...Array(5)].map((_, index) => (
      <Star
        key={index}
        className={`w-4 h-4 ${
          index < rating ? "text-orange-500 fill-orange-500" : "text-gray-300"
        }`}
      />
    ));
  };

  const renderEditableStars = (rating, onChange) => {
    return [...Array(5)].map((_, index) => (
      <Star
        key={index}
        className={`w-5 h-5 cursor-pointer ${
          index < rating
            ? "text-orange-500 fill-orange-500"
            : "text-gray-300 hover:text-orange-300"
        }`}
        onClick={() => onChange(index + 1)}
      />
    ));
  };

  return (
    <div className="min-h-screen bg-white">
      <div className="w-full text-left mx-auto p-6">
        <div className="mb-8 w-full flex  justify-between items-center">
          <div className="flex flex-col justify-start item-start">
            <h1 className="text-3xl font-bold text-gray-900 mb-2">
              Product Reviews
            </h1>
            <p className="text-gray-600">Manage and moderate product reviews</p>
          </div>
          <div
            className="w-full pointer flex justify-center item-center text-sm bg-[#f3f3f3] text-[#222] rounded-full w-[121px] h-[34px]"
            onClick={() => setShowCustomComponent(true)}
          >
            <Plus /> Add
          </div>
        </div>

        <div className="space-y-4">
          {reviews.map((review) => (
            <div
              key={review.reviewid}
              className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow"
            >
              {editingId === review.reviewid ? (
                // Edit Mode
                <div className="space-y-4">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-3">
                      <div className="w-10 h-10 bg-orange-500 rounded-full flex items-center justify-center text-white font-semibold">
                        {review.username.charAt(0).toUpperCase()}
                      </div>
                      <div>
                        <p className="font-semibold text-gray-900">
                          {review.username}
                        </p>
                        <p className="text-sm text-gray-500">
                          {new Date(review.created_at).toLocaleDateString()}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="space-y-3">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Rating
                      </label>
                      <div className="flex items-center space-x-1">
                        {renderEditableStars(editForm.rating, (rating) =>
                          setEditForm({ ...editForm, rating })
                        )}
                      </div>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Review Text
                      </label>
                      <textarea
                        value={editForm.review_text}
                        onChange={(e) =>
                          setEditForm({
                            ...editForm,
                            review_text: e.target.value,
                          })
                        }
                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none resize-none"
                        rows="3"
                        placeholder="Write your review here..."
                      />
                    </div>
                  </div>

                  <div className="flex items-center space-x-3">
                    <button
                      onClick={() => handleSave(review)}
                      className="flex items-center space-x-2 bg-orange-500 text-white px-4 py-2 rounded-lg hover:bg-orange-600 transition-colors"
                    >
                      <Save className="w-4 h-4" />
                      <span>Save</span>
                    </button>
                    <button
                      onClick={handleCancel}
                      className="flex items-center space-x-2 bg-gray-500 text-white px-4 py-2 rounded-lg hover:bg-gray-600 transition-colors"
                    >
                      <X className="w-4 h-4" />
                      <span>Cancel</span>
                    </button>
                  </div>
                </div>
              ) : (
                // View Mode
                <>
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center space-x-3">
                      <div className="w-10 h-10 bg-orange-500 rounded-full flex items-center justify-center text-white font-semibold">
                        {review.username.charAt(0).toUpperCase()}
                      </div>
                      <div>
                        <p className="font-semibold text-gray-900">
                          {review.username}
                        </p>
                        <p className="text-sm text-gray-500">
                          {new Date(review.created_at).toLocaleDateString()}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center space-x-2">
                      <button
                        onClick={() => handleEdit(review)}
                        className="flex items-center space-x-1 text-orange-600 hover:text-orange-700 px-3 py-1 rounded-lg hover:bg-orange-50 transition-colors"
                      >
                        <Edit className="w-4 h-4" />
                        <span>Edit</span>
                      </button>
                      <button
                        onClick={() => handleDelete(review.reviewid)}
                        className="flex items-center space-x-1 text-red-600 hover:text-red-700 px-3 py-1 rounded-lg hover:bg-red-50 transition-colors"
                      >
                        <Trash2 className="w-4 h-4" />
                        <span>Delete</span>
                      </button>
                    </div>
                  </div>

                  <div className="flex items-center space-x-1 mb-3">
                    {renderStars(review.rating)}
                    <span className="ml-2 text-sm text-gray-600">
                      ({review.rating}/5)
                    </span>
                  </div>

                  <p className="text-gray-700 leading-relaxed">
                    {review.review_text}
                  </p>

                  <div className="mt-4 pt-3 border-t border-gray-100">
                    <div className="flex items-center justify-between text-xs text-gray-500">
                      <span>Review ID: {review.reviewid}</span>
                      <span>Product ID: {review.product_id}</span>
                      <span>User ID: {review.userid}</span>
                    </div>
                  </div>
                </>
              )}
            </div>
          ))}
        </div>

        {showCustomComponent && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto">
              <div className="flex items-center justify-between p-4 border-b border-gray-200">
                <h2 className="text-lg font-semibold text-gray-900">
                  Custom Component
                </h2>
                <button
                  onClick={() => setShowCustomComponent(false)}
                  className="text-gray-400 hover:text-gray-600 transition-colors"
                >
                  <X className="w-6 h-6" />
                </button>
              </div>

              <AddReview />

              <div className="p-4 border-t border-gray-200 flex justify-end">
                <button
                  onClick={() => setShowCustomComponent(false)}
                  className="bg-gray-500 text-white px-4 py-2 rounded-lg hover:bg-gray-600 transition-colors"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}

        {reviews.length === 0 && (
          <div className="text-center py-12">
            <p className="text-gray-500 text-lg">No reviews found</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AllReviews;
